import { useSystemStatus } from "../Context/SystemStatusProvider.tsx";
import { WarningComponent } from "./WarningComponent.js";

export const SystemStatusAlert = ({ children }) => {
  const { statusMessage, statusHeader } = useSystemStatus();
  if (statusMessage && statusHeader) {
    return <WarningComponent message={statusMessage} header={statusHeader} />;
  }

  return <>{children}</>;
};
